import './main.less';
import React from 'react';
import PropTypes from 'prop-types';
import { reduxForm, Field } from 'redux-form';

import SelectField from '../../../shared/form-elements/select/field';
import InputField from '../../../shared/form-elements/input';
import ModalBox from '../../../shared/modal';

const Form = props => (
	<div className="poll-create__wrap">
		<form action="" className="ui-form" onSubmit={props.handleSubmit(data => props.formSubmit(data))}>
			<div className="ui-form__element">
				<Field
					name="form_url"
					placeholder={props.intl('Form url, e.g. ') + 'https://everad.typeform.com/to/r5zXoD...'}
					component={InputField}
					disabled={props.isEditModePollForm}
				/>
			</div>
			<div className="ui-form__element">
				<Field
					name="status"
					placeholder={props.intl('Status')}
					component={SelectField}
					searchable={false}
					clearable={false}
					options={props.statusesList}
				/>
			</div>
			<div className="ui-form__element">
				<Field
					name="language"
					placeholder={props.intl('Language')}
					component={SelectField}
					searchable={false}
					clearable={false}
					options={props.languagesList}
				/>
			</div>
			<div className="ui-form__element buttons-wrap">
				<button className="ui-btn ui-btn-primary">{props.intl('Save')}</button>
			</div>
		</form>
	</div>
);

const Main = props => (
	<ModalBox
		title={props.intl('Create poll')}
		body={Form(props)}
		isOpen={props.shouldShowPollForm}
		onClose={props.togglePollForm}
		className="create-poll-modal"
	/>
);

Form.propTypes = {
	intl: PropTypes.func,
	handleSubmit: PropTypes.func,
	formSubmit: PropTypes.func,
	statusesList: PropTypes.array,
	languagesList: PropTypes.array,
	isEditModePollForm: PropTypes.bool
};

Main.propTypes = {
	intl: PropTypes.func,
	shouldShowPollForm: PropTypes.bool,
	togglePollForm: PropTypes.func
};

export default formName =>
	reduxForm({
		form: formName
	})(Main);



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/polls/components/poll-form/main.js